import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import TempStorage from "../../components/Storage.js";
import Loader from "../../visualComponents/Loader.js";
import NavBar from "../../visualComponents/NavBarGenerale.js";

let isLoading = false;

const ResocontoPiano = ({ isVisible, setIsVisible, infoCodice, setInfoCodice, confirm }) => {

    const handleAnnulla = () => {
        const input = document.querySelector('input');
        input.removeAttribute('disabled');
        setInfoCodice("");
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="mt-1">
            <h2 className="mb-3">Revisione del piano</h2>
            <p className="mb-2">Nome: {infoCodice.Nome}</p>
            <p className="mb-2">Descrizione: {infoCodice.Descrizione}</p>
            <div className='mb-5 grid grid-cols-2'>
                <button
                    onClick={handleAnnulla}
                    className="mr-1 rounded-lg py-2 px-4 bg-red-500 hover:bg-red-700 text-white font-bold"
                >
                    Annulla
                </button>
                <button
                    onClick={() => confirm(false)}
                    className="ml-1 rounded-lg py-2 px-4 bg-green-500 hover:bg-green-700 text-white font-bold"
                >
                    Conferma
                </button>
            </div>
        </div>
    );
};

const AttivazioneDominio = () => {
    const [codiceDominio, setCodiceDominio] = useState("");
    const [ragioneSociale, setRagioneSociale] = useState("");
    const [indirizzo, setIndirizzo] = useState("");
    const [cap, setCap] = useState("");
    const [citta, setCitta] = useState("");
    const [provincia, setProvincia] = useState("");
    const [nomeManager, setNomeManager] = useState("");
    const [cognomeManager, setCognomeManager] = useState("");
    const [emailManager, setEmailManager] = useState("");
    const [passwordManager, setPasswordManager] = useState("");
    const [codiceAtt, setCodiceAtt] = useState("");
    const [infoCodiceAtt, setInfoCodiceAtt] = useState({});
    const [isResocontoVisible, setIsResocontoVisible] = useState(false);
    const [durataTrial, setDurataTrial] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        if (TempStorage.exists('infoDominio')) {
            const infoDominio = TempStorage.get('infoDominio');
            setCodiceDominio(infoDominio.codice);
            setRagioneSociale(infoDominio.ragione);
            setIndirizzo(infoDominio.indirizzo);
            setCap(infoDominio.cap);
            setCitta(infoDominio.citta);
            setProvincia(infoDominio.provincia);
            setNomeManager(infoDominio.nome);
            setCognomeManager(infoDominio.cognome);
            setEmailManager(infoDominio.email);
            setPasswordManager(infoDominio.password);

            onload();
        }
    }, []);

    const onload = async () => {
        const response = await fetch('/getParametri', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        const data = await response.json();

        if (response.status === 500) {
            alert(data["error"]);
            console.log(data["error"]);
            navigate('/login');
        }
        else {
            setDurataTrial(data[0].DurataTrialMesi);
        }
    };

    const checkCodice = async () => {
        try {
            const response = await fetch('/checkCodiceAttivazione', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ CodiceAtt: codiceAtt }),
            });

            const data = await response.json();

            if (response.status === 200) {
                if (data[0].Obsoleto) {
                    alert('Licenza obsoleta');
                    setCodiceAtt("");
                    return;
                };

                if (data[0].DataAttivazione !== null) {
                    alert('Licenza già utilizzata');
                    setCodiceAtt("");
                    return;
                };

                setInfoCodiceAtt(data[0]);
                setIsResocontoVisible(true);
                const input = document.querySelector('input');
                input.setAttribute('disabled', 'true');
            }
            else {
                alert(data["error"]);
            }
        } catch (error) {
            alert('Errore nella connessione al server');
            console.log(error);

        }

    };

    const handleModifica = () => {
        navigate('/dominio');
    };

    const confirm = async (IsTrial) => {
        try {
            isLoading = true;
            const response = await fetch('/setupDominio', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    Nome: nomeManager,
                    Cognome: cognomeManager,
                    Email: emailManager,
                    Password: passwordManager,
                    Livello: "Manager",
                    CodiceDominio: codiceDominio,
                    Stato: "Attivo",
                    IDLicenza: IsTrial ? "" : infoCodiceAtt.ID,
                    Indirizzo: indirizzo,
                    CAP: cap,
                    Citta: citta,
                    Provincia: provincia,
                    RagioneSociale: ragioneSociale,
                    PreavvisoManutenzione: 30,
                    InvioMailRiepilogo: true,
                    GiorniMailRiepilogo: 7,
                    IsTrial: IsTrial
                })
            });

            if (response.status !== 200) {
                const data = await response.json();
                alert(data["error"]);
                navigate('/');
            };

            isLoading = false;

            TempStorage.remove('infoDominio');
            navigate('/');
        } catch (error) {
            console.log(error);
            alert('Errore nella connessione al server');
            navigate('/');
        }
    };

    return (
        <div className="flex justify-center min-h-screen bg-white dark:bg-gray-800">
            <NavBar page={"MANTEGO"}/>
            {isLoading && <Loader />}
            <div className="p-4 w-full max-w-lg text-center bg-white dark:bg-gray-800 text-black dark:text-white">
                <h1 className="mb-5 mt-14">ATTIVA IL TUO DOMINIO<br />oppure <b><u className="text-blue-600 cursor-pointer" onClick={() => navigate('/')}>esegui la login</u></b></h1>
                <h2 className="mb-3">Revisione del dominio</h2>
                <p className="mb-2">Codice/P.IVA: {codiceDominio}</p>
                <p className="mb-2">Ragione Sociale: {ragioneSociale}</p>
                <p className="mb-2">Indirizzo: {indirizzo}</p>
                <p className="mb-2">CAP: {cap}</p>
                <p className="mb-2">Città: {citta}</p>
                <p className="mb-2">Provincia: {provincia}</p>
                <button className="rounded-lg py-2 px-4 border-2 w-2/4 mb-5" onClick={handleModifica}>Modifica</button>
                <div className="mb-2 grid grid-cols-2 items-center">
                    <p className="justify-self-start">Codice di attivazione: </p>
                    <div className="relative flex items-center">
                        <input
                            type="text"
                            value={codiceAtt}
                            onChange={(e) => setCodiceAtt(e.target.value)}
                            onBlur={checkCodice}
                            onKeyDown={(e) => e.key === "Enter" && checkCodice()}
                            className="locked rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1"
                        />
                    </div>
                </div>
                {
                    !isResocontoVisible &&
                    <>
                        <p className="mt-2">oppure</p>
                        <button
                            onClick={() => confirm(true)}
                            className="rounded-lg py-2 px-4 bg-blue-500 hover:bg-blue-700 text-white font-bold mt-2"
                        >
                            ATTIVA IL TRIAL DI {durataTrial} MESI
                        </button>
                    </>
                }
                <ResocontoPiano
                    isVisible={isResocontoVisible}
                    setIsVisible={setIsResocontoVisible}
                    infoCodice={infoCodiceAtt}
                    setInfoCodice={setInfoCodiceAtt}
                    confirm={confirm}
                />
            </div>
        </div>
    );
};

export default AttivazioneDominio;